import "@/App.css";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import PulsePage from "@/pages/PulsePage";
import ComprehensionPage from "@/pages/ComprehensionPage";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/marketing/Home";
import Features from "@/pages/marketing/Features";
import HowItWorks from "@/pages/marketing/HowItWorks";
import Pricing from "@/pages/marketing/Pricing";
import Consultants from "@/pages/marketing/Consultants";
import AuthPage from "@/pages/AuthPage";
import AppLayout from "@/components/app/AppLayout";
import Dashboard from "@/pages/app/Dashboard";
import Changes from "@/pages/app/Changes";
import ChangeDetail from "@/pages/app/ChangeDetail";
import SponsorHome from "@/pages/app/SponsorHome";
import DigestPage from "@/pages/DigestPage";
import UpdatePrompt from "@/components/system/UpdatePrompt";
import CalendarPage from "@/pages/app/CalendarPage";
import Templates from "@/pages/app/Templates";
import Audit from "@/pages/app/Audit";
import StakeholderMap from "@/pages/app/StakeholderMap2";
import Welcome from "@/pages/app/Welcome";
import StartWizard from "@/pages/app/StartWizard";
import Settings from "@/pages/app/Settings";
import Learn from "@/pages/app/Learn";
import Portfolio from "@/pages/app/Portfolio";
import Vault from "@/pages/app/Vault";
import Admin from "@/pages/app/Admin";
import ErrorBoundary from "@/components/system/ErrorBoundary";
import LearnArticle from "@/pages/app/LearnArticle";
import AcceptInvite from "@/pages/AcceptInvite";
import ReadinessCheck from "@/pages/marketing/ReadinessCheck";
import Terms from "@/pages/marketing/Terms";
import Privacy from "@/pages/marketing/Privacy";
import Contact from "@/pages/marketing/Contact";
import Unsubscribe from "@/pages/marketing/Unsubscribe";
import Guide from "@/pages/marketing/Guide";
import Resources from "@/pages/marketing/Resources";
import ResourceArticle from "@/pages/marketing/ResourceArticle";
import NotFound from "@/pages/marketing/NotFound";

// Belt and braces for the pre-mount redirect in index.js: if the router ever sees /login.html, send it to /login with the query intact.
function LegacyLogin() {
  const { search, hash } = window.location;
  return <Navigate to={`/login${search}${hash}`} replace />;
}

export default function App() {
  return (
    <div className="App">
      <ErrorBoundary scope="app" title="ChangeOS hit a problem">
      <AuthProvider>
        <BrowserRouter>
          <UpdatePrompt />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/consultants" element={<Consultants />} />
            <Route path="/login" element={<AuthPage />} />
            <Route path="/login.html" element={<LegacyLogin />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/pulse/:token" element={<PulsePage />} />
            <Route path="/check/:token" element={<ComprehensionPage />} />
            <Route path="/digest/:token" element={<DigestPage />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/readiness-check" element={<ReadinessCheck />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<ResourceArticle />} />
            <Route path="/app" element={<AppLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="welcome" element={<Welcome />} />
              <Route path="start" element={<StartWizard />} />
              <Route path="changes" element={<Changes />} />
              <Route path="changes/:id" element={<ChangeDetail />} />
              <Route path="sponsor" element={<SponsorHome />} />
              <Route path="stakeholders" element={<StakeholderMap />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="templates" element={<Templates />} />
              <Route path="audit" element={<Audit />} />
              <Route path="settings" element={<Settings />} />
              <Route path="learn" element={<Learn />} />
              <Route path="portfolio" element={<Portfolio />} />
              <Route path="vault" element={<Vault />} />
              <Route path="admin" element={<Admin />} />
              <Route path="learn/:slug" element={<LearnArticle />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}
